exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tool-bar[data-v-0b70d295]{margin-bottom:20px}.video-area[data-v-0b70d295]{height:450px;margin-bottom:10px}", ""]);

// exports
